import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MANIFESTO } from "./data";
import { SectionHeading } from "./Services";

const SIDE_IMG =
  "https://images.pexels.com/photos/8085262/pexels-photo-8085262.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700";

export const Manifesto = () => {
  const imgRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: imgRef, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="why-us" className="border-y border-[#D4AF37]/10 bg-[#F3EEE2]" data-testid="why-us-section">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-5 py-28 sm:px-8 sm:py-36 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <div className="lg:sticky lg:top-28">
            <SectionHeading id="why-us" overline="The Manifesto" title="Why serious students" accent="choose us." />
            <div ref={imgRef} className="relative overflow-hidden rounded-xl border border-[#D4AF37]/20">
              <motion.img
                style={{ y }}
                src={SIDE_IMG}
                alt="Student studying late in a library"
                loading="lazy"
                className="h-[420px] w-full scale-110 object-cover"
              />
              <div className="absolute inset-0 bg-white/35" />
              <div className="absolute bottom-5 left-5 rounded-lg border border-[#D4AF37]/30 bg-white/85 px-4 py-3 backdrop-blur-md">
                <p className="font-serif-display text-lg italic text-[#12294D]">"Quality is remembered long after the deadline is met."</p>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-3">
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.num}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.75, delay: 0.08 * i, ease: [0.33, 1, 0.68, 1] }}
              className="group flex gap-8 border-t border-[#D4AF37]/15 py-12 last:border-b sm:gap-12"
              data-testid={`manifesto-chapter-${m.num}`}
            >
              <span className="font-serif-display text-6xl font-light text-[#A07E1F]/35 transition-colors duration-500 group-hover:text-[#A07E1F] sm:text-7xl">
                {m.num}
              </span>
              <div>
                <h3 className="font-serif-display text-2xl font-semibold text-[#12294D] sm:text-3xl">{m.title}</h3>
                <p className="mt-4 max-w-xl text-sm leading-relaxed text-[#5E6E85] sm:text-base">{m.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
